import { getRewardTransactionsApi } from "../components/constant/Api";
import { myApi } from "./api";

export const rewardTransactionApi = myApi.injectEndpoints({
    endpoints: (builder) => ({
        getRewardTransactions: builder.query({
            query: (params) => {
                return {
                    url: getRewardTransactionsApi,
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["rewardTransactions"],
        }),
    }),
});

export const { useGetRewardTransactionsQuery } = rewardTransactionApi;
